import { RouterProvider } from '@tanstack/react-router';
import { OturumSaglayici } from './lib/oturum';
import { SenkronSaglayici } from './lib/senkron';
import { router } from './router';

export function App() {
  return (
    <OturumSaglayici>
      <SenkronSaglayici>
        <RouterProvider router={router} />
      </SenkronSaglayici>
    </OturumSaglayici>
  );
}
